import { cloneDeep } from 'lodash';
import { InterviewScoreEnum, InterviewScore, TechnicalValidationCompetency } from '@/types/api';
import { numberedTechnicalScores, TECHNICAL_VALIDATION_COMPETENCIES } from '@/utils/interviews';
import { convertReviewIntoTechnicalValidationCompetencies } from '@/utils/technicalChallenge';

const getStringfiedValue = (score: number, type: InterviewScoreEnum): string => {
  if (numberedTechnicalScores.includes(type)) {
    return String(score);
  }

  return score === 0 ? 'No' : 'Yes';
};

const getPersistedScoreByEnum = (
  scoreEnum: InterviewScoreEnum,
  persistedScoreList: InterviewScore[]
): InterviewScore | undefined => {
  return persistedScoreList?.find((score) => score.scoreType === scoreEnum);
};

const getPersistedCompetencyByName = (
  name: string,
  persistedCompetencyList: any[]
): any | undefined => {
  return persistedCompetencyList?.find((competency) => competency.competency.name === name);
};

export const formatCompetencies = ({
  scores,
  competencies,
}: {
  scores: InterviewScore[];
  competencies?: TechnicalValidationCompetency[];
}): TechnicalValidationCompetency[] => {
  if (!competencies) {
    return [];
  }

  const wasReviewCreatedWithGradingRubric =
    !!competencies?.[0]?.scores?.[0]?.technicalChallengeCompetencyScore;

  if (wasReviewCreatedWithGradingRubric) {
    return convertReviewIntoTechnicalValidationCompetencies({ competencies });
  }

  const currentCompetencies = cloneDeep(TECHNICAL_VALIDATION_COMPETENCIES);

  currentCompetencies.forEach((competency, competencyIndex) => {
    competency.scores.forEach((input, inputIndex) => {
      const foundCompetency = getPersistedCompetencyByName(competency.name, competencies);

      if (foundCompetency) {
        currentCompetencies[competencyIndex].additionalInfo = foundCompetency.additionalInfo;
      }

      const foundScore = getPersistedScoreByEnum(input.name as InterviewScoreEnum, scores);

      if (foundScore) {
        const rawScore = foundScore.score / (competency.weight || 1);
        currentCompetencies[competencyIndex].scores[inputIndex] = {
          ...input,
          id: foundScore.id,
          value: getStringfiedValue(rawScore, foundScore.scoreType),
          scoreValue: rawScore, // Convert weighted score from DB to raw score
        };
      }
    });
  });

  return currentCompetencies;
};
